// extracted by mini-css-extract-plugin
module.exports = {"borderTop":"tabs_borderTop__3PGNM","indicator":"tabs_indicator__2uNtS","total":"tabs_total__L_645"};